import Common from "../common/Common";
import { SimpleScrollTrigger } from "simple-scroll-trigger";

class ScrollTrigger1 {
  constructor() {
    this.common = new Common();
    this.elements1 = document.querySelectorAll(".scrollTrigger1[data-scroll]");
    this.elements2 = document.querySelectorAll(".scrollTrigger2[data-scroll]");
    //this.scroll = null;

    if (this.elements1) {
      this.initialize();
    }
  }

  initialize() {
    this.elements1.forEach(( element , i ) => {
      new SimpleScrollTrigger({
        trigger: element,
        onEnter: () => {
          element.classList.add("is-enter");
        },
        startViewPortPoint: { value: 100, unit: "%", from: "top" },
        startTriggerPoint: { value: 10, unit: "%", from: "top" },
        endViewPortPoint: { value: 0, unit: "%", from: "bottom" },
        endTriggerPoint: { value: 100, unit: "%", from: "bottom" },
        isOnce: true,
        initOnEnter: true/*{ range: "end" }*/,
        initOnLeave: false
      });
    });

    this.elements2.forEach(( element , i ) => {
      const items = element.querySelectorAll(".scrollTrigger2__item1");
      items.forEach(( item , j ) => {
        new SimpleScrollTrigger({
          trigger: item,
          onEnter: () => {
            setTimeout((function() {
              item.classList.add("is-enter");
            }), 80 * j)
          },
          startViewPortPoint: { value: 100, unit: "%", from: "top" },
          startTriggerPoint: { value: 10, unit: "%", from: "top" },
          endViewPortPoint: { value: 0, unit: "%", from: "bottom" },
          endTriggerPoint: { value: 100, unit: "%", from: "bottom" },
          isOnce: true,
          initOnEnter: true/*{ range: "end" }*/,
          initOnLeave: false
        });
      });
    });
  }
}

export default ScrollTrigger1;
